<template>
  <div>
    <el-container>
      <el-header height="50px">
        <topAsideMenu
          ref="topAsideMenu"
          @menuSelectedItemChanged="menuSelectedItemChanged"
          :userInfo="userInfo"
          :noticeList="noticeList"
          :menuListForDev="menuListForDev"
        ></topAsideMenu>
      </el-header>
      <el-container>
        <el-aside class="left-aside" :width="leftAsideWidth">
          <leftAsideMenu
            :leftMenuListForDev="leftMenuListForDev"
            :noticeList="noticeList"
            :isCollapse="elLeftMenu.isCollapse"
          ></leftAsideMenu>
        </el-aside>
        <el-container>
          <div
            :class="{leftslider:true,leftsliderf:elLeftMenu.isCollapse}"
            :title="elLeftMenu.isCollapse?'展开':'收缩'"
            @click="leftMenuExpends"
          ></div>
          <el-main :style="{height:mainHeight+'px'}">
            <breadcrumb v-if="showBreadCrumb"></breadcrumb>
            <!-- <span @click="elLeftMenu.isCollapse=!elLeftMenu.isCollapse">dsfdsfdsf</span> -->
            <router-view
              class="router-child-container"
              @bindQyexAccount="bindQyexAccount"
              @changeBreadCrumbStatus="changeBreadCrumbStatus"
              @updateNotice="updateNotice(true)"
              :style="{height:mainHeight-centerdistance+'px'}"
            ></router-view>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import leftAsideMenu from "../components/menu/leftAsideMenu.vue";
import topAsideMenu from "../components/menu/topAsideMenu";
import breadcrumb from "../components/menu/breadcrumb";
import dateformat from "../helper/dateformat";
import Vue from "Vue";
export default {
  /**
   * 组件
   */
  components: {
    leftAsideMenu,
    topAsideMenu,
    breadcrumb
  },
  /**
   * 数字
   */
  data() {
    return {
      menuListForDev: [],
      leftMenuListForDev: [],
      userInfo: {},
      showBreadCrumb: true,
      noticeList: [],
      elLeftMenu: {
        isCollapse: false,
        uniqueOpened: true,
        collapseTransition: true
      },
      leftAsideWidth: "205px",
      checked: true,
      centerdistance: 110,
      mainHeight: 600
    };
  },
  /**
   * 监听Vue实例上的数据变动
   */
  watch: {
    "elLeftMenu.isCollapse"() {
      if (this.elLeftMenu.isCollapse) this.leftAsideWidth = "64px";
      else this.leftAsideWidth = "205px";
    }
  },

  /**
   * 方法、函数
   */
  methods: {
    /**
     * 在Main页面点击绑定企业微信按钮事件
     */
    bindQyexAccount: function() {
      this.$refs.topAsideMenu.showBindQywx();
    },
    changeBreadCrumbStatus: function(status) {
      this.showBreadCrumb = status;
      if (!this.showBreadCrumb) this.centerdistance -= 90;
      else this.centerdistance += 90;
    },
    updateNotice: function(isrefresh = false) {
      this.getUserNotice(isrefresh);
    },
    /**
     * 展开收缩
     */
    leftMenuExpends: function() {
      this.elLeftMenu.isCollapse = !this.elLeftMenu.isCollapse;
    },
    menuSelectedItemChanged: function(id) {
      this.leftMenuListForDev = this.menuListForDev.find(a => a.id == id).child;
      this.$forceUpdate();
    },
    setMainBodyHeight: function() {
      this.mainHeight = document.documentElement.clientHeight - 50;
    },
    hasNewNotice: function(newNotice) {
      try {
        let newNoticeArray = [];
        newNotice.forEach(item => {
          if (this.noticeList.findIndex(a => a.id == item.id) < 0)
            newNoticeArray.push(item);
        });
        return newNoticeArray;
      } catch (err) {
        return [];
      }
    },
    getUserNotice: async function(refresh = false) {
      let newNotice = await this.http.get(
        "/systemnotice/getusernoreadnoticelist"
      );
      let newNoticeArray = this.hasNewNotice(newNotice);
      if (newNoticeArray.length > 0) {
        if (this.noticeList.length == 0) this.noticeList = newNoticeArray;
        else this.noticeList = this.noticeList.concat(newNoticeArray);
        newNoticeArray.forEach(item => {
          this.$message({
            message: `<a style="color:#67c23a;" href="https://oa.chuangqi168.com/api/systemnotice/readnoticeandredirect?id=${item.id}&ck=${item.redirecturl}">${item.title}</a>`,
            type: "success",
            showClose: true,
            duration: 6000,
            dangerouslyUseHTMLString: true,
            customClass: "noticemessage"
          });
        });
      }
      if (refresh) this.noticeList = newNotice;
    }
  },
  /**
   * 完成挂载
   */
  mounted() {
    window.onresize = _ => {
      this.setMainBodyHeight();
    };
  },
  /**
   * 更新完成状态
   */
  updated: function() {},
  /**
   * 完成了 data 数据的初始化
   */
  async created() {
    this.setMainBodyHeight();
    this.showBreadCrumb = true;
    try {
      this.elementLoding("加载中...");
      //    this.menuListForDev = await this.$store.getters["menu/menuListForDev"];
      this.menuListForDev = await this.http.get("/menu/getmenulist");
      this.userInfo = await this.http.get("/user/getloginuserinfo");
      if (
        this.userInfo &&
        (this.userInfo.avatar == "" || this.userInfo.avatar == null)
      ) {
        this.userInfo.avatar = "/apistatic/files/2019/6/1561104791401.png";
      }
      if (this.menuListForDev && this.menuListForDev.length > 0) {
        this.leftMenuListForDev = this.menuListForDev[0].child;
      }
      await this.updateRouter();
      await this.$forceUpdate();
      this.elementLodingClose();
    } catch (err) {
      this.elementLodingClose();
    }
  }
};
</script>
<style>
.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>


// WEBPACK FOOTER //
// src/view/index.vue